import { AskConsumerLayout } from "@ui/layouts/AskConsumerLayout/AskConsumerLayout";
import { DiscoveryAsk } from "./DiscoveryAsk";

export const NewQuestionApp = () => {
	return (
		<AskConsumerLayout title="New question" signedOutTopNav>
			<div class="askgvt-page">
				<DiscoveryAsk />
			</div>
		</AskConsumerLayout>
	);
};
